import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Tooltip,
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useTranslation } from 'react-i18next';
import { CURRENCY_TO_COUNTRY } from '../../constants';

interface ReverseRatesTableProps {
    fromCurrency: string;
    selectedCurrencies: string[];
    exchangeRates: { [key: string]: number };
    isRefreshing: boolean;
    onRefresh: () => void;
}

const ReverseRatesTable = ({
    fromCurrency,
    selectedCurrencies,
    exchangeRates,
    isRefreshing,
    onRefresh,
}: ReverseRatesTableProps) => {
    const { t } = useTranslation();
    
    return (
        <Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant="h5">
                    {t('rates.reverseRates')} ({fromCurrency})
                </Typography>
                <Tooltip title={t('common.refresh')}>
                    <IconButton onClick={onRefresh} disabled={isRefreshing}>
                        <RefreshIcon />
                    </IconButton>
                </Tooltip>
            </Box>
            <TableContainer>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>{t('common.currency')}</TableCell>
                            <TableCell>{t('rates.targetCurrency')}</TableCell>
                            <TableCell align="right">{t('rates.rate')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {selectedCurrencies.map((currency) => {
                            const info = CURRENCY_TO_COUNTRY[currency];
                            const isIRR = currency === 'IRR';

                            // If currency is the same as fromCurrency, rate should be 1
                            const rate = currency === fromCurrency ? 1 : exchangeRates[currency];

                            const displayRate = rate ? (
                                isIRR ? (
                                    (1 / rate).toFixed(8)
                                ) : (
                                    (1 / rate).toFixed(8)
                                )
                            ) : t('common.loading');

                            return (
                                <TableRow key={currency}>
                                    <TableCell>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <span>{info.flag}</span>
                                            <span>{currency}</span>
                                        </Box>
                                    </TableCell>
                                    <TableCell>{info.name}</TableCell>
                                    <TableCell align="right">
                                        {displayRate}
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default ReverseRatesTable; 